export enum VideoHeartbeatErrorSubType {
	CROSS_ORIGIN = 'CrossOrigin',
	MULTICAST = 'Multicast',
	PLAYBACK = 'Playback'
}
